import { CardList } from "../components/CardList";
import { DashboardLayout } from "../components/DashboardLayout";
import { PostForm } from "../components/PostForm";
import { Post } from "../components/Post";
import { usePopulateList } from "../hooks/usePopulateList";
import { fetchPostsByType } from "../services/api/posts";
import { useSelector } from "react-redux";
import { usePopulateSearchResults } from "../hooks/usePopulateSearchResults";
import { RootState } from "../redux/store";

export const Ads = () => {
  const searchTerm = useSelector((state: RootState) => state.search.searchTerm);

  const {
    searchResults,
    searchHasNextPage,
    searchFetchNextPage,
    searchIsFetching,
    searchRefetch,
    showSearch,
  } = usePopulateSearchResults({
    queryKey: `fetch${searchTerm}Ads`,
    searchType: "ads",
  });

  const { pages, hasNextPage, fetchNextPage, isFetching, refetch } =
    usePopulateList({
      queryFn: () => fetchPostsByType("2"),
      queryKey: "fetchAllAds",
    });

  return (
    <DashboardLayout
      pageTitle="Ads"
      refetch={!showSearch ? refetch : searchRefetch}
      modalInner={<PostForm />}
    >
      <CardList
        data={!showSearch ? pages : searchResults}
        hasNextPage={!showSearch ? hasNextPage : searchHasNextPage}
        fetchNextPage={!showSearch ? fetchNextPage : searchFetchNextPage}
        isFetching={!showSearch ? isFetching : searchIsFetching}
        component={<Post />}
        listType="ads"
        showFooter
      />
    </DashboardLayout>
  );
};
